
var exceltable = {

    init: function(tableEl) {
        tableEl.find('.dd-options').keydown(function (event) {
            var me = $(this);
            console.log('dd-options', event.keyCode, me);
            var keyCode = event.keyCode;
            if (keyCode === 39 || keyCode === 9) { // arrow-right, tab
                if (keyCode === 9 && event.shiftKey) {
                    return exceltable.selectPreviousCell(me);
                } else {
                    return exceltable.selectNextCell(me);
                }
            }
            if (keyCode === 37) { // arrow-left
                return exceltable.selectPreviousCell(me);
            }
            var char = event.key;
            var selected = me.find('.dd-option-selected');
            var siblings = me.find('.dd-option:gt('+selected.index()+')').find('[data-val^="'+char+'"]');
            if (siblings.length === 0) {
                siblings = me.find('[data-val^="'+char+'"]');
            }
            if (siblings.length > 0) {
                var dd = me.closest('.dd-container');
                $(siblings[0]).parent().trigger('click.ddslick');
                setTimeout(function() {
                    dd.ddslick('open');
                }, 50);
                return true;
            }
        });
        tableEl.find('input,textarea,[contenteditable],button').not(':hidden').keydown(function (event) {
            var me = $(this);
            var t;
            console.log(event.keyCode, me);
            var keyCode = event.keyCode;
            if (me.is('textarea') && keyCode === 13) {
                return true;
            }
            if (me.is('[contenteditable]') && keyCode === 13) {
                return true;
            }

            var newPos = null;
            if (keyCode === 27) { // esc
                me.val(me.attr('data-val'));
                return false;
            }

            if (keyCode === 113) { // F2
                me.putCursorAtEnd();
                return false;
            }

            if (keyCode === 39 || keyCode === 13 || keyCode === 9) { // arrow-right, enter, tab
                t = exceltable.getCaretPosition(me);
                console.log(t);
                if (keyCode === 9 && event.shiftKey) {
                    return exceltable.selectPreviousCell(me);
                } else if (keyCode === 9 || t === me.val().length) {
                    return exceltable.selectNextCell(me);
                } else {
                    return true;
                }
            }
            if (keyCode === 37) { // arrow-left
                t = exceltable.getCaretPosition(me);
                console.log(t);
                if (t === 0) {
                    return exceltable.selectPreviousCell(me);
                } else {
                    return true;
                }
            }
            if (keyCode === 38) { // arrow-up
                return exceltable.selectAboveCell(me);
            }
            if (keyCode === 40) { // arrow-down
                return exceltable.selectBelowCell(me);
            }
            return true;
        });
        tableEl.find('input,[contenteditable],button').focusout(function (event) {
            var me = $(this);
            me.removeClass('hasfocus');
        });
        tableEl.find('input,[contenteditable],button').mousedown(function (event) {
            var me = $(this);
            if (!me.is(':focus')) {
                console.log('select-all', me);
                if (me.is('.dd-selected')) {
                    exceltable.selectDdSlick(me);
                } else {
                    exceltable.selectElementContent(me);
                }
            }
        });

        exceltable.autoHeight({ which: 0 }, tableEl.find('textarea'));
        tableEl.find('textarea').mousemove(function(e) {
            var myPos = $(this).offset();
            myPos.bottom = $(this).offset().top + $(this).outerHeight();
            myPos.right = $(this).offset().left + $(this).outerWidth();

            if (myPos.bottom > e.pageY && e.pageY > myPos.bottom - 16 && myPos.right > e.pageX && e.pageX > myPos.right - 16) {
                $(this).css({ cursor: "nw-resize" });
            }
            else {
                $(this).css({ cursor: "" });
            }
        })
        .keyup(function(e) {
            exceltable.autoHeight(e, $(this));
        });
    },

    selectNextCell: function(me) {
        var newPos = exceltable.findNextRightOf(me);
        console.log('selectNextCell', newPos);
        return exceltable.selectCell(newPos);
    },

    selectPreviousCell: function(me) {
        var newPos = exceltable.findNextLeftOf(me);
        console.log('selectPreviousCell', newPos);
        return exceltable.selectCell(newPos);
    },

    selectAboveCell: function(me) {
        var tbl = me.parents('table');
        var col = me.parents('td');
        var row = me.parents('tr');
        var colIndex = row.find('td').index(col);
        var rowIndex = tbl.find('tr').index(row) - 1;

        row = $(tbl.find('tr')[rowIndex]);
        var newPos = $(row.find('td')[colIndex]).find('input,textarea,[contenteditable],button');
        var i = 0;
        while (newPos.length === 0 && i < 30) {
            rowIndex--;
            i++;
            row = $(tbl.find('tr')[rowIndex]);
            newPos = $(row.find('td')[colIndex]).find('input,textarea,[contenteditable],button');
        }
        return exceltable.selectCell(newPos);
    },

    selectBelowCell: function(me) {
        var tbl = me.parents('table');
        var col = me.parents('td');
        var row = me.parents('tr');
        var colIndex = row.find('td').index(col);
        var rowIndex = tbl.find('tr').index(row) + 1;

        row = $(tbl.find('tr')[rowIndex]);
        var newPos = $(row.find('td')[colIndex]).find('input,textarea,[contenteditable],button');
        var i = 0;
        while (newPos.length === 0 && i < 30) {
            rowIndex++;
            i++;
            row = $(tbl.find('tr')[rowIndex]);
            newPos = $(row.find('td')[colIndex]).find('input,textarea,[contenteditable],button');
        }
        return exceltable.selectCell(newPos);
    },

    selectCell: function(newPos) {
        if (newPos != null && newPos.length > 0) {
            console.log('new focus', newPos);
            if (newPos.is('.dd-selected')) {
                exceltable.selectDdSlick(newPos);
            } else {
                exceltable.selectElementContent(newPos);
            }
            return false;
        }
        return true;
    },

    selectDdSlick: function(el) {
        if (!el.is(".hasfocus")) {
            $('.hasfocus').removeClass('hasfocus');
            el.addClass('hasfocus').focus();
            (window.getSelection ? window.getSelection() : document.selection).empty();
            el.closest('.dd-container').ddslick('open');
        }
    },

    selectElementContent: function(el) {
        var div = el[0];
        if (!el.is(".hasfocus")) {
            window.setTimeout(function () {
                console.log("select all", el);
                var sel, range;
                if (window.getSelection && document.createRange) {
                    console.log("createRange");
                    range = document.createRange();
                    range.selectNodeContents(div);
                    sel = window.getSelection();
                    sel.removeAllRanges();
                    sel.addRange(range);
                } else if (document.body.createTextRange) {
                    console.log("createTextRange");
                    range = document.body.createTextRange();
                    range.moveToElementText(div);
                    range.select();
                }
            }, 1);
            $('.hasfocus').removeClass('hasfocus');
            el.addClass('hasfocus');
        }
    },

    getCaretPosition: function(el) {
        var editableDiv = el[0];
        var caretPos = 0,
            sel, range;
        if (window.getSelection) {
            sel = window.getSelection();
            if (sel.rangeCount) {
                range = sel.getRangeAt(0);
                if (range.commonAncestorContainer.parentNode === editableDiv) {
                    caretPos = range.endOffset;
                }
            }
        } else if (document.selection && document.selection.createRange) {
            range = document.selection.createRange();
            if (range.parentElement() === editableDiv) {
                var tempEl = document.createElement("span");
                editableDiv.insertBefore(tempEl, editableDiv.firstChild);
                var tempRange = range.duplicate();
                tempRange.moveToElementText(tempEl);
                tempRange.setEndPoint("EndToEnd", range);
                caretPos = tempRange.text.length;
            }
        }
        return caretPos;
    },

    findNextRightOf: function(inputEl) {
        var next = (inputEl.is('td') ? inputEl.nextAll('td:not(.not-available):first') : inputEl.parents('td').nextAll('td:not(.not-available):first'));
        if (next.length === 0) return null;
        var newPos = next.find('input,textarea,[contenteditable],button').not(':hidden');
        if (newPos.is('[disabled]') || newPos.length === 0) {
            return exceltable.findNextRightOf(next);
        }
        return newPos;
    },

    findNextLeftOf: function(inputEl) {
        console.log('findNextLeftOf', inputEl);
        var next = (inputEl.is('td') ? inputEl.prevAll('td:not(.not-available):first') : inputEl.parents('td').prevAll('td:not(.not-available):first'));
        if (next.length === 0) return null;
        var newPos = next.find('input,textarea,[contenteditable],button').not(':hidden');
        if (newPos.is('[disabled]') || newPos.length === 0) {
            return exceltable.findNextLeftOf(next);
        }
        return newPos;
    },

    autoHeight: function(e, els) {
        $.each(els, function(i, el) {
            //  this if statement checks to see if backspace or delete was pressed, if so, it resets the height of the box so it can be resized properly
            if (e.which === 8 || e.which === 46) {
                $(this).height(parseFloat($(this).css("min-height")) !== 0 ? parseFloat($(this).css("min-height")) : parseFloat($(this).css("font-size")));
            }
            //  the following will help the text expand as typing takes place
            while($(this).outerHeight() < this.scrollHeight + parseFloat($(this).css("borderTopWidth")) + parseFloat($(this).css("borderBottomWidth"))) {
                $(this).height($(this).height()+1);
            };
        });
    }

};
window.exceltable = exceltable;

jQuery.fn.putCursorAtEnd = function() {
    return this.each(function() {
        $(this).focus()
        // If this function exists...
        if (this.setSelectionRange) {
            // ... then use it (Doesn't work in IE)
            // Double the length because Opera is inconsistent about whether a carriage return is one character or two. Sigh.
            var len = $(this).val().length * 2;
            this.setSelectionRange(len, len);
        } else {
            // ... otherwise replace the contents with itself
            // (Doesn't work in Google Chrome)
            $(this).val($(this).val());
        }
        // Scroll to the bottom, in case we're in a tall textarea
        // (Necessary for Firefox and Google Chrome)
        this.scrollTop = 999999;
    });
};
